import { getCachedCountries } from "../../../../../Utils/phoneCountriesCache"
import { browserCountryFromTimeZone } from "../../../../../Utils/timezoneCountries"

// The browser TIME ZONE is the primary signal: it comes from the OS clock, so it says
// where the device actually is, and it is always present. The browser language list is
// only a fallback now, because it reports the INTERFACE language and failed two ways:
// an English browser in Ukraine resolved to GB, and a language carrying no country at
// all ("en" rather than "en-GB") resolved to nothing, leaving the field blank.
// True IP GeoIP would need backend infrastructure; this stays dependency-free.
const detectRegion = () => {
  const fromZone = browserCountryFromTimeZone()
  if (fromZone) return fromZone
  const loc = (navigator.languages && navigator.languages[0]) || navigator.language || ""
  try {
    return new Intl.Locale(loc).region || (loc.split("-")[1] || "").toUpperCase() || null
  } catch {
    return (loc.split("-")[1] || "").toUpperCase() || null
  }
}

// Default the phone country to the merchant's region when they haven't picked one yet.
// Never overwrites a choice they have already made.
export const defaultPhoneCountry = () => {
  const region = detectRegion()
  if (!region) return null
  const match = (getCachedCountries() || []).find(
    (c) => (c.country_code || "").toUpperCase() === region
  )
  return match
    ? { code: match.code, countryCode: match.country_code, name: match.name, id: match.id }
    : null
}
